var render = function render(){var _vm=this,_c=_vm._self._c;return _c('money',_vm._b({staticClass:"form-control br-10",attrs:{"value":+_vm.value},on:{"input":function($event){return _vm.emitir($event)}}},'money',_vm.moneyOptions,false))
}
var staticRenderFns = []

export { render, staticRenderFns }